module.exports = __webpack_public_path__ + "img/baloto.4dda022.png";